import { GetInsuranceListRes } from "./Model";
export const GET_PATIENT_INSURANCE_LIST_LOADING =
  "GET_PATIENT_INSURANCE_LIST_LOADING";
export const GET_PATIENT_INSURANCE_LIST_SUCCESS =
  "GET_PATIENT_INSURANCE_LIST_SUCCESS";
export const GET_PATIENT_INSURANCE_LIST_FAIL = "GET_PATIENT_INSURANCE_LIST_FAIL";
export const GET_PATIENT_INSURANCE_LIST_API_MSG =
  "GET_PATIENT_INSURANCE_LIST_API_MSG";
export const GET_PATIENT_INSURANCE_LIST_API_RES =
  "GET_PATIENT_INSURANCE_LIST_API_RES";

export interface GetPatientInsuranceListState {
  getPatientInsuranceListRes: GetInsuranceListRes;
  loading: boolean;
  successMsg: string;
  errorMsg: string;
  status: number;
}
export interface GetPatientInsuranceListLoading {
  type: typeof GET_PATIENT_INSURANCE_LIST_LOADING;
  loading: boolean;
}
export interface GetPatientInsuranceListSuccess {
  type: typeof GET_PATIENT_INSURANCE_LIST_SUCCESS;
  payload: GetInsuranceListRes;
  successMsg: string;
}
export interface GetPatientInsuranceListFail {
  type: typeof GET_PATIENT_INSURANCE_LIST_FAIL;
  payload: GetInsuranceListRes;
  errorMsg: string;
  status: number;
}
export interface GetPatientInsuranceListAPIMsg {
  type: typeof GET_PATIENT_INSURANCE_LIST_API_MSG;
  payload: GetInsuranceListRes;
  successMsg: string
  errorMsg: string;
  status: number;
}
export interface GetPatientInsuranceListAPIRes {
  type: typeof GET_PATIENT_INSURANCE_LIST_API_RES;
  payload: GetInsuranceListRes;
  successMsg: string
  errorMsg: string;
  status: number;
}

export type GetPatientInsuranceListActionTypes =
  | GetPatientInsuranceListLoading
  | GetPatientInsuranceListSuccess
  | GetPatientInsuranceListFail
  | GetPatientInsuranceListAPIMsg
  | GetPatientInsuranceListAPIRes;
